(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[0] + '/analizy/struktura.json',
    wersja: __pewniaki_inline_cfg[1],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[2] + '/lata/',
    kod:    '' + __pewniaki_inline_cfg[3] + '',
    en:     JSON.parse(String(__pewniaki_inline_cfg[4])),
    // Fallback, gdyby JSON na serwerze byl sprzed dopisania naglowka pula/typuje.
    pula:   JSON.parse(String(__pewniaki_inline_cfg[5])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[6])),
    tys: function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); },
    f1: function (v) { return v == null ? '—' : window.PEWNIAKI_ANALIZA.tys((Math.round(v * 10) / 10).toFixed(1)).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); },
    // Zakres lat: suma SUROWYCH licznikow dekad z rocznikow (plan V2 §5.3).
    sumujLata: function (roczniki) {
        var dekady = {}, N = 0;
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.dekady || {}).forEach(function (d) { dekady[d] = (dekady[d] || 0) + r.dekady[d]; });
        });
        return { losowan: N, dekady: dekady };
    },
    // Teksty z tr() — jeden slownik dla wnioskow i renderu (jezyk wybiera serwer).
    T: {
        brakD:  __pewniaki_inline_cfg[7],
        brakZ:  __pewniaki_inline_cfg[8],
        lider:  __pewniaki_inline_cfg[9],
        histor: __pewniaki_inline_cfg[10],
        opis:   __pewniaki_inline_cfg[11],
        brakO:  __pewniaki_inline_cfg[12],
        brakW:  __pewniaki_inline_cfg[13],
        aria:   __pewniaki_inline_cfg[14],
        desc:   __pewniaki_inline_cfg[15],
        slup:   __pewniaki_inline_cfg[16],
        linia:  __pewniaki_inline_cfg[17],
        legenda:__pewniaki_inline_cfg[18],
        nad:    __pewniaki_inline_cfg[19],
        pod:    __pewniaki_inline_cfg[20],
        zdanie: __pewniaki_inline_cfg[21]
    },
    wnioski: function (o) {
        var T = window.PEWNIAKI_ANALIZA.T;
        if (!o) return [T.brakD];
        var h = o.dekady || {}, keys = Object.keys(h).sort(function(a,b) { return h[b]-h[a] || String(a).localeCompare(String(b)); });
        if (!keys.length || !o.losowan) return [T.brakZ];
        return [T.lider.replace('%1', keys[0]).replace('%2', h[keys[0]]).replace('%3', o.losowan), T.histor];
    },
    // Wykres z tych samych `wiersze`, ktore trafily do tabeli — ta sama geometria co SSR.
    wykres: function (wiersze, N, maxIle) {
        var api = window.PEWNIAKI_ANALIZA, T = api.T, tys = api.tys, f1 = api.f1;
        var wyk = document.querySelector('[data-dekady-wykres]');
        if (!wyk) { return; }
        wyk.replaceChildren();
        var maxOczek = wiersze.reduce(function (m, w) { return w.oczek != null && w.oczek > m ? w.oczek : m; }, 0);
        var maxY = Math.max(maxIle, maxOczek), ileDek = wiersze.length;
        if (!(N > 0 && ileDek > 0 && maxY > 0)) {
            var brak = document.createElement('p'); brak.className = __pewniaki_inline_cfg[22];
            brak.textContent = T.brakW;
            wyk.appendChild(brak); return;
        }
        var ns = 'http://www.w3.org/2000/svg', lewy = 40, gora = 12, poleH = 140, dol = gora + poleH, szer = 360;
        var slot = (szer - lewy - 12) / ileDek, slW = slot * 0.55, skala = poleH / maxY;
        var el = function (tag, at, txt) { var e = document.createElementNS(ns, tag); Object.keys(at).forEach(function (a) { e.setAttribute(a, String(at[a])); }); if (txt != null) { e.textContent = txt; } return e; };
        var svg = el('svg', { 'data-dekady-svg': '', role: 'img', viewBox: '0 0 ' + szer + ' 190', preserveAspectRatio: __pewniaki_inline_cfg[23],
            'aria-label': T.aria.replace('%1', ileDek).replace('%2', tys(N)) });
        svg.classList.add('wykres-dekady','gra-tekst--'+api.kod);
        svg.appendChild(el('desc', {}, T.desc));
        svg.appendChild(el('line', { x1: lewy, y1: gora, x2: lewy, y2: dol, stroke: '#94A3B8', 'stroke-width': 1 }));
        svg.appendChild(el('line', { x1: lewy, y1: dol, x2: szer - 6, y2: dol, stroke: '#94A3B8', 'stroke-width': 1 }));
        svg.appendChild(el('text', { x: lewy - 6, y: dol + 4, 'text-anchor': 'end', 'font-size': 9, fill: '#475569' }, '0'));
        svg.appendChild(el('text', { x: lewy - 6, y: gora + 4, 'text-anchor': 'end', 'font-size': 9, fill: '#475569' }, Math.round(maxY) === maxY ? tys(maxY) : f1(maxY)));
        var pkt = [];
        wiersze.forEach(function (w, i) {
            var cx = lewy + i * slot + slot / 2, wys = w.ile * skala;
            var opis = T.slup.replace('%1', w.dekada).replace('%2', tys(w.ile)).replace('%3', f1(w.oczek)).replace('%4', tys(N));
            var g = el('g', { 'data-dekady-bar': w.dekada, 'data-count': w.ile, tabindex: 0, 'aria-label': opis });
            g.appendChild(el('title', {}, opis));
            g.appendChild(el('rect', { x: (cx - slW / 2).toFixed(2), y: (dol - wys).toFixed(2), width: slW.toFixed(2), height: wys.toFixed(2), rx: 2, fill: 'currentColor' }));
            svg.appendChild(g);
            svg.appendChild(el('text', { x: cx.toFixed(1), y: dol + 14, 'text-anchor': 'middle', 'font-size': 10, fill: '#475569', 'aria-hidden': 'true' }, w.dekada));
            if (w.oczek != null) { pkt.push(cx.toFixed(1) + ',' + (dol - w.oczek * skala).toFixed(1)); }
        });
        if (pkt.length) {
            var linia = el('polyline', { 'data-dekady-model': '', points: pkt.join(' '), fill: 'none', stroke: '#F97316', 'stroke-width': 2, 'stroke-dasharray': '6 4', 'stroke-linejoin': 'round' });
            linia.appendChild(el('title', {}, T.linia));
            svg.appendChild(linia);
        }
        wyk.appendChild(svg);
        var legenda = document.createElement('p'); legenda.className = 'tekst-maly';
        legenda.textContent = T.legenda;
        wyk.appendChild(legenda);
    },
    render: function (okno, klucz, dane) {
        var api = window.PEWNIAKI_ANALIZA;
        var q = function (s) { return document.querySelector(s); };
        var tys = api.tys, f1 = api.f1;
        var zn = function (v) { return v == null ? '—' : (v >= 0 ? '+' : '−') + f1(Math.abs(v)); };
        var sekcja = q('[data-dekady]');
        if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
        if (sekcja) { sekcja.hidden = false; }
        var pula = Number(dane.pula) || api.pula, typuje = Number(dane.typuje) || api.typuje;
        var N = okno.losowan || 0, M = N * typuje, mapa = okno.dekady || {};
        var klucze = Object.keys(mapa).sort(function (a, b) { return Number(a.split('-')[0]) - Number(b.split('-')[0]); });
        var maxIle = 0, nad = null, pod = null;
        var wiersze = klucze.map(function (d) {
            var cz = d.split('-'), rozmiar = Number(cz[1]) - Number(cz[0]) + 1, ile = mapa[d] || 0;
            var oczek = pula > 0 ? M * rozmiar / pula : null;
            var w = { dekada: d, ile: ile, oczek: oczek, roznica: oczek == null ? null : ile - oczek };
            if (ile > maxIle) { maxIle = ile; }
            if (w.roznica != null) {
                if (!nad || w.roznica > nad.roznica) { nad = w; }
                if (!pod || w.roznica < pod.roznica) { pod = w; }
            }
            return w;
        });
        q('[data-dekady-n]').textContent = tys(N);
        q('[data-dekady-m]').textContent = tys(M);
        api.wykres(wiersze, N, maxIle);
        q('[data-dekady-tabela] tbody').innerHTML = wiersze.map(function (w) {
            return '<tr><td class="liczbowa">' + w.dekada + '</td><td class="liczbowa">' + tys(w.ile) + '</td><td class="liczbowa">'
                 + (M ? f1(w.ile * 100 / M) : '—') + '%'
                 + (maxIle ? __pewniaki_inline_cfg[24] + Math.round(w.ile * 100 / maxIle) + '" ></div></div>' : '')
                 + '</td><td class="liczbowa">' + f1(w.oczek) + '</td><td class="liczbowa">' + zn(w.roznica) + '</td></tr>';
        }).join('');
        var T = api.T;
        var opis = function (w, znak) { return w ? T.opis.replace('%1', tys(w.ile)).replace('%2', f1(w.oczek)).replace('%3', znak + f1(Math.abs(w.roznica))) : T.brakO; };
        q('[data-dekady-nad]').textContent = nad ? nad.dekada : '—';
        q('[data-dekady-nad-opis]').textContent = opis(nad, '+');
        q('[data-dekady-pod]').textContent = pod ? pod.dekada : '—';
        q('[data-dekady-pod-opis]').textContent = opis(pod, '−');
        // zdania: pod tabela i te same w bloku „Co wynika" (jesli liczba punktow sie zgadza)
        var punkty = [];
        if (nad && N > 0) {
            punkty.push(T.nad.replace('%1', tys(N)).replace('%2', nad.dekada).replace('%3', tys(nad.ile))
                .replace('%4', f1(nad.oczek)).replace('%5', f1(Math.abs(nad.roznica))));
        }
        if (pod && N > 0 && (!nad || pod.dekada !== nad.dekada)) {
            punkty.push(T.pod.replace('%1', pod.dekada).replace('%2', tys(pod.ile)).replace('%3', f1(pod.oczek)).replace('%4', f1(Math.abs(pod.roznica))));
        }
        q('[data-dekady-zdanie]').textContent = (nad && pod && N > 0)
            ? T.zdanie.replace('%1', tys(N)).replace('%2', nad.dekada).replace('%3', f1(Math.abs(nad.roznica)))
                .replace('%4', pod.dekada).replace('%5', f1(Math.abs(pod.roznica)))
            : '';
        var zdania = document.querySelectorAll('.wniosek .wniosek__zdanie');
        if (zdania.length === punkty.length) {
            Array.prototype.forEach.call(zdania, function (el, i) { el.textContent = punkty[i]; });
        }
    }
};
})();
